"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"

import { ActiveVehicle, clearActiveVehicle } from "@lib/data/fitment"
import LocalizedClientLink from "@modules/common/components/localized-client-link"

const ActiveVehicleBanner = ({ vehicle }: { vehicle: ActiveVehicle }) => {
  const router = useRouter()
  const [isClearing, setIsClearing] = useState(false)

  const handleClear = async () => {
    setIsClearing(true)

    try {
      await clearActiveVehicle()
      router.refresh()
    } finally {
      setIsClearing(false)
    }
  }

  return (
    <div
      className="flex items-center justify-center gap-x-3 py-2 px-4 bg-ui-bg-subtle border-b border-ui-border-base text-small-regular text-ui-fg-subtle"
      data-testid="active-vehicle-banner"
    >
      <span>
        Shopping for:{" "}
        <span className="text-ui-fg-base font-medium">
          {vehicle.year} {vehicle.make} {vehicle.model}
        </span>
      </span>
      <LocalizedClientLink
        href="/vehicle"
        className="underline hover:text-ui-fg-base"
        data-testid="active-vehicle-change"
      >
        change
      </LocalizedClientLink>
      <button
        type="button"
        onClick={handleClear}
        disabled={isClearing}
        className="underline hover:text-ui-fg-base disabled:opacity-50"
        data-testid="active-vehicle-clear"
      >
        clear
      </button>
    </div>
  )
}

export default ActiveVehicleBanner
